var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.354,
    height: 17.895,
    viewBox: "0 0 22.354 17.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947",
    transform: "translate(-7.755 -9.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "share-svgrepo-com_1_",
    "data-name": "share-svgrepo-com (1)",
    d: "M1,18.866A11.142,11.142,0,0,1,10.211,7.953V5.564a2.3,2.3,0,0,1,3.716-1.818l8.538,6.641a2.3,2.3,0,0,1,0,3.635l-8.538,6.641a2.3,2.3,0,0,1-3.716-1.818V16.829A7.859,7.859,0,0,0,5.02,20.068,2.192,2.192,0,0,1,1,18.866Zm11.67-13.5a.256.256,0,0,0-.413.2v4A.262.262,0,0,1,12,9.82a9.21,9.21,0,0,0-8.273,5.624,8.88,8.88,0,0,0-.681,3.322q0,.049,0,.1a.145.145,0,0,0,.265.075l.05-.075h0A8.749,8.749,0,0,1,4.51,17.493a9.229,9.229,0,0,1,.934-.795A11.3,11.3,0,0,1,12,14.595a.252.252,0,0,1,.256.253v4a.256.256,0,0,0,.413.2l8.538-6.641a.256.256,0,0,0,0-.4Z",
    transform: "translate(6.755 6.728)",
    fill: "#40aeee",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ed8222d3d2fbe5439cca15c542549012.svg";
export { ForwardRef as ReactComponent };